// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tN","title":"tO","notSelected":"tP","duration":"tQ","image":"tR","infoWrapper":"tS","description":"tT"};